import { css } from 'styled-components';
import { Device, from } from './media';
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export const headerOverlap = css `
  margin-top: -46px;

  @media ${from(Device.Desktop)} {
    margin-top: -104px;
  }

  .no-header & {
    margin-top: 0 !important;
  }
`;
export const headerOverlapPadding = css `
  --headerHeight: 46px;

  padding-top: var(--headerHeight);

  @media ${from(Device.Desktop)} {
    --headerHeight: 104px;
  }

  .no-header & {
    padding-top: 0 !important;
  }
`;
export const highlightTitleWords = (title) => title.replaceAll(/\*([\w\W]+)\*/g, '<span>$1</span>');
